import { ApiService } from "./api.service";
export default class TerminologyService extends ApiService {
  namespace = "terminology";
  icon = "Lightning";
  name = "Terminology";
  DOMAIN = -11;
  favicon = "Lightning";
  window = 290;
  Width = 690;
  action = "action";

  constructor() {
    super("terminologies");
  }
}
